import { useTheme } from '@mui/material';
import { useMemo } from 'react';

import type { SxProps, Theme } from '../../../../themes/themes';

export const useStyles = (): { [key: string]: SxProps } => {
  const theme = useTheme<Theme>();
  return useMemo(
    () => ({
      header: {
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: theme.zIndex.drawer + 10,
        width: '100%',
        pointerEvents: 'none',
      },
      paper: {
        minWidth: '70%',
      },
      level2Navigation: {
        pointerEvents: 'auto',
      },
      content: {
        display: 'flex',
        marginTop: `calc(${theme.spacing(12)} + ${theme.spacing(12)})`,
        overflow: 'hidden',
        overflowY: 'auto',
        height: '100%',
      },
      panels: {
        display: 'flex',
        flexDirection: 'row',
      },
      panelX: {
        width: '288px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        left: 0,
        top: 0,
        background: 'white',
        borderLeft: `0px solid ${theme.palette.grey[300]}`,
        '&:nth-of-type(1n+2)': {
          borderLeft: `1px solid ${theme.palette.grey[300]}`,
        },
        '&:nth-of-type(1)': {
          width: '264px',
          '& > *': {
            left: 0,
          },
        },
      },
      panelZ: {
        position: 'absolute',
        left: '24px',
        top: 0,
      },
      tab: {
        color: theme.palette.text.primary,
        '&::after': { backgroundColor: theme.palette.text.primary },
      },
      isDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          display: 'block',
        },
      },
      offContainer: {
        position: 'fixed',
        left: 0,
        top: -1000,
        zIndex: 100,
        width: '100%',
        height: 0,
      },
      hidden: {
        visibility: 'hidden',
      },
    }),
    [theme]
  );
};
